// @ts-nocheck
import { toRefs, computed } from "vue";
import { pick } from "lodash-es";
import { ElSelect, ElTable, ElPagination } from "element-plus";
import type { Ref } from "vue";
export const usePagination = (
  props,
  { attrs },
  {
    currentPage
  }: {
    select: Ref<InstanceType<typeof ElSelect> | undefined>;
    table: Ref<InstanceType<typeof ElTable> | undefined>;
    key: Ref<string>;
    filter: (query: string) => void;
    currentPage: Ref<number>;
  }
) => {
  const pageCount = computed(() => {
    if (props.total) {
      return Math.ceil(props.total / (props.pageSize || 10));
    }
    return 1;
  });

  const result = {
    ...pick(toRefs(props), Object.keys(ElPagination.props)),
    currentPage: currentPage,
    small: true,
    pageCount: pageCount,
    layout: "total, prev, pager, next",
    hideOnSinglePage: true,
    onCurrentChange: (value) => {
      currentPage.value = value;
      attrs.onCurrentChange?.(value);
    }
  };
  return result;
};
